import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { put, takeLatest, all } from 'redux-saga/effects';

import {
  CREATE_ORDER_REQUEST,
  GET_EXISTING_GUEST_ORDERS_REQUEST,
  GET_EXISTING_ORDER_REQUEST,
  GET_ORDER_DELIVERY_DETAILS_REQUEST,
  SET_EXISTING_ORDERS,
  SET_ORDER,
  SET_ORDER_DELIVERY_DETAILS
} from './order.action';
import { mapOrderDeliveryStatus, mapOrderDeliveryStatusDescription } from './order.mapper';

import { createGetRequest, createPostRequest } from '../tools/tools';

function* createOrder({ order, onComplete }) {
  try {
    const user = getAuth().currentUser;
    const [endpoint, requestOptions] = yield createPostRequest(user, '/order', order);

    const response = yield axios(endpoint, requestOptions);

    yield put({ type: SET_ORDER, data: response.data, error: undefined });
    if (onComplete) yield onComplete(response.data, null);
  } catch (error) {
    yield put({ type: SET_ORDER, data: undefined, error });
    if (onComplete) yield onComplete(null, error);
  }
}

function* watchCreateOrder() {
  yield takeLatest(CREATE_ORDER_REQUEST, createOrder);
}

function* existingOrder({ onComplete }) {
  try {
    const user = getAuth().currentUser;
    const [endpoint, requestOptions] = yield createGetRequest(user, `/order/user/${user.uid}`);

    const response = yield axios(endpoint, requestOptions);

    yield put({ type: SET_EXISTING_ORDERS, data: response.data, error: undefined });
    if (onComplete) yield onComplete(response.data, null);
  } catch (error) {
    yield put({ type: SET_EXISTING_ORDERS, data: undefined, error });
    if (onComplete) yield onComplete(null, error);
  }
}

function* watchGetExistingOrder() {
  yield takeLatest(GET_EXISTING_ORDER_REQUEST, existingOrder);
}

function* existingGuestOrders({ email, phone, onComplete }) {
  try {
    const user = getAuth().currentUser;
    const [endpoint, requestOptions] = yield createGetRequest(
      user,
      `/order/guest?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}`
    );

    const response = yield axios(endpoint, requestOptions);

    yield put({ type: SET_EXISTING_ORDERS, data: response.data, error: undefined });
    if (onComplete) yield onComplete(response.data, null);
  } catch (error) {
    yield put({ type: SET_EXISTING_ORDERS, data: undefined, error });
    if (onComplete) yield onComplete(null, error);
  }
}

function* watchGetExistingGuestOrders() {
  yield takeLatest(GET_EXISTING_GUEST_ORDERS_REQUEST, existingGuestOrders);
}

function* getOrderDeliveryDetails({ orderNumber, onComplete }) {
  try {
    const user = getAuth().currentUser;
    const [endpoint, requestOptions] = yield createGetRequest(
      user,
      `/order/${orderNumber}/delivery-details`
    );
    const response = yield axios(endpoint, requestOptions);

    const first = response.data;
    const status = mapOrderDeliveryStatus(first?.status);
    const description = mapOrderDeliveryStatusDescription(status);

    const deliveryData = {
      status,
      description,
      deliveryDate: first?.expectedDeliveryDate || '-',
      trackingLink: first.trackingLink
    };

    yield put({
      type: SET_ORDER_DELIVERY_DETAILS,
      orderNumber,
      deliveryData,
      error: undefined
    });

    if (onComplete) yield onComplete(deliveryData, null);
  } catch (error) {
    yield put({
      type: SET_ORDER_DELIVERY_DETAILS,
      orderNumber,
      deliveryData: { status: 'Error', deliveryDate: 'N/A' },
      error
    });
    if (onComplete) yield onComplete(null, error);
  }
}

function* watchGetOrderDeliveryDetails() {
  yield takeLatest(GET_ORDER_DELIVERY_DETAILS_REQUEST, getOrderDeliveryDetails);
}

export default function* watchOrders() {
  yield all([
    watchCreateOrder(),
    watchGetExistingOrder(),
    watchGetExistingGuestOrders(),
    watchGetOrderDeliveryDetails()
  ]);
}
